export const POST_FUEL_DATA_COMPLETENESS_REPORT =
  'POST_FUEL_DATA_COMPLETENESS_REPORT';
export const CLEAR_FUEL_DATA_COMPLETENESS_REPORT =
  'CLEAR_FUEL_DATA_COMPLETENESS_REPORT';
export const FLAG_FUEL_DATA_COMPLETENESS_REPORT_ACTIVITY =
  'FLAG_FUEL_DATA_COMPLETENESS_REPORT_ACTIVITY';
